import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import Button from 'ant-design-vue/lib/button';
// import 'ant-design-vue/lib/button/style';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/fonts/font.css'
createApp(App).use(store).use(router).use(Antd).mount('#app')
